import { useKeystrokes } from "@src/hooks/useKeystrokes";
import { ReactNode, FC, useState, useCallback } from "react";
import ModalContext, { ModalContextState } from "../../contexts/ModalContext";

type Props = {
  children: ReactNode;
};

export const ModalProvider: FC<Props> = (props: Props) => {
  const [components, setComponents] = useState<ReactNode[]>([]);
  const showModal: ModalContextState["showModal"] = useCallback(
    (component: ReactNode, args) => {
      setComponents((prevComponents) => {
        if (args?.replace) {
          return [component];
        }
        return [...prevComponents, component];
      });
    },
    [setComponents],
  );
  const closeModal: ModalContextState["closeModal"] = useCallback(
    (args?) => {
      if (args?.closeAll) {
        setComponents([]);
      } else {
        setComponents((prevComponents) => {
          if (prevComponents.length > 0) {
            return prevComponents.slice(0, -1);
          }
          return [];
        });
      }
    },
    [setComponents],
  );
  const state = {
    components,
    showModal,
    closeModal,
    modalIsOpen: components.length > 0,
  };

  useKeystrokes({
    Escape: () => closeModal(),
  });
  return (
    <ModalContext.Provider value={state}>
      {props.children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
